import styled from "styled-components";

export const StyledLink = styled.div`
    display: block;
`;
